import { openBlock as t, createElementBlock as n, renderSlot as o, createVNode as r, Transition as i, withCtx as s, createElementVNode as d, createCommentVNode as l } from "vue";
/* empty css                                             */
import c from "../../../_virtual/_plugin-vue_export-helper.js";
const _ = {
  name: "DsHeaderNavigationHorizontalSlideOver",
  props: {
    /**
         * Slide over opened state
         * */
    opened: { type: Boolean, default: !1 },
    /**
         * With transition, when this is set the slide over will appear animated
         * */
    withTransition: { type: Boolean, default: !0 }
  },
  data: () => ({
    internalOpened: !1
  }),
  computed: {
    transitionName() {
      return this.withTransition ? "ds-header-slide-over__container__slide-transition" : "";
    }
  },
  watch: {
    opened(e) {
      this.$nextTick(() => {
        this.internalOpened = e;
      });
    }
  }
}, p = { class: "ds-header-slide-over" }, m = {
  key: 0,
  class: "ds-header-slide-over__container"
}, h = { class: "ds-header-slide-over__container__content" };
function f(e, u, v, N, $, a) {
  return t(), n("div", p, [
    o(e.$slots, "button"),
    r(i, {
      name: a.transitionName,
      appear: ""
    }, {
      default: s(() => [
        e.internalOpened ? (t(), n("div", m, [
          d("div", h, [
            o(e.$slots, "content")
          ])
        ])) : l("", !0)
      ]),
      _: 3
    }, 8, ["name"])
  ]);
}
const B = /* @__PURE__ */ c(_, [["render", f]]);
export {
  B as default
};
